export const dashboardRoutes = {
  label: 'Dashboard',
  labelDisable: true,
  children: [
    {
      name: 'Dashboard',
      icon: 'chart-pie',
      to: '/app/dashboard',
      active: true
    }
  ]
};
export const appRoutes = {
  label: 'Módulos',
  labelDisable: true,
  children: [
    {
      name: 'Processos',
      icon: 'layer-group',
      to: '/app/process/process-list',
      active: true
    },
    //  {
    //   name: 'Drawback',
    //   icon: ['fab', 'trello'],
    //   to: '/app/drawback',
    //   active: true
    // },
    // {
    //   name: 'Processos Tab',
    //   icon: 'layer-group',
    //   to: '/app/process/process-tabs',
    //   active: true
    // }
    // {
    //   name: 'Kanban',
    //   icon: ['fab', 'trello'],
    //   to: '/app/process/process-kanban',
    //   active: true
    // }
  ]
};

// export const appKanban = {
//   label: 'Kanban',
//   children: [
//     // {
//     //   name: 'Embarque',
//     //   icon: ['fab', 'trello'],
//     //   to: '/app/process/process-kanban',
//     //   active: true
//     // },
//     // {
//     //   name: 'Emb. - Impo.',
//     //   icon: ['fab', 'trello'],
//     //   to: '/app/process/process-kanban',
//     //   active: true
//     // },
//     {
//       name: 'Processos',
//       icon: ['fab', 'trello'],
//       to: '/app/process/process-kanbani',
//       active: true
//     }
//   ]
// };

export default [
  dashboardRoutes,
  appRoutes,
  // appKanban
  // pagesRoutes,
  // modulesRoutes,
  // documentationRoutes
];
